var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 179,
    viewBox: "0 0 193 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3209_49034)",
    filter: "url(#filter0_d_3209_49034)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M136.316 28.4355H38.3086V160.033H136.316V28.4355Z",
    fill: "url(#paint0_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.53 30.2217H39.5847V157.229H134.53V30.2217Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6562 35.5771H46.9871V36.597H79.6562V35.5771Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M79.6562 40.167H46.9871V41.1868H79.6562V40.167Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.175 35.5771H84.5059V36.597H117.175V35.5771Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.278 64.6523H89.6091V65.6722H122.278V64.6523Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.045 67.4561H90.3762V68.4759H123.045V67.4561Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.577 70.2627H91.9082V71.2825H124.577V70.2627Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.278 109.792H89.6091V110.812H122.278V109.792Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.045 112.599H90.3762V113.618H123.045V112.599Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.577 115.402H91.9082V116.422H124.577V115.402Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.9531 54.1943H47.2427V89.389H81.9531V54.1943Z",
    fill: "url(#paint1_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.6252 54.9609H47.4612V88.6247H81.6252V54.9609Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.5304 57H48.6655V78.9322H80.5304V57Z",
    fill: "url(#paint2_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.3098 57.2559H48.8843V78.4237H80.3098V57.2559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.2201 77.6595L54.1339 65.4169L57.4515 70.7717L64.5981 63.3772L70.7241 70.7717L76.083 59.8066L89.8649 81.7389L45.1995 80.208L46.2201 77.6595Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.3463 62.6109C53.6149 62.6109 54.6433 61.5833 54.6433 60.3157C54.6433 59.0481 53.6149 58.0205 52.3463 58.0205C51.0777 58.0205 50.0493 59.0481 50.0493 60.3157C50.0493 61.5833 51.0777 62.6109 52.3463 62.6109Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.9531 99.3359H47.2427V134.531H81.9531V99.3359Z",
    fill: "url(#paint3_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.6252 100.101H47.4612V133.764H81.6252V100.101Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.5304 102.143H48.6655V124.075H80.5304V102.143Z",
    fill: "url(#paint4_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.3098 102.396H48.8843V123.563H80.3098V102.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.2201 122.799L54.1339 110.557L57.4515 115.913L64.5981 108.517L70.7241 115.913L76.083 104.946L89.8649 126.879L45.1995 125.35L46.2201 122.799Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.3463 107.753C53.6149 107.753 54.6433 106.725 54.6433 105.457C54.6433 104.19 53.6149 103.162 52.3463 103.162C51.0777 103.162 50.0493 104.19 50.0493 105.457C50.0493 106.725 51.0777 107.753 52.3463 107.753Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.3677 21.9332L52.697 151.007L148.825 170.096L174.495 41.022L78.3677 21.9332Z",
    fill: "url(#paint5_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.2704 23.9336L54.4951 148.505L147.619 166.997L172.395 42.426L79.2704 23.9336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.986 44.1512L84.8967 31.0273L84.6978 32.0276L150.787 45.1515L150.986 44.1512Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.181 138.707L66.0918 125.583L65.8929 126.583L131.982 139.707L132.181 138.707Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.015 141.475L64.9458 131.334L64.7469 132.334L115.816 142.475L116.015 141.475Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.8264 140.867L63.802 137.089L63.6031 138.089L82.6275 141.867L82.8264 140.867Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.794 43.343L83.7507 36.7812L83.5518 37.7815L116.595 44.3432L116.794 43.343Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.188 54.3653L82.6089 42.5342L82.4099 43.5345L141.989 55.3655L142.188 54.3653Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M95.9822 51.1721L81.4636 48.2891L81.2647 49.2894L95.7833 52.1724L95.9822 51.1721Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.41 67.1658L80.3206 54.042L80.1216 55.0423L146.211 68.1661L146.41 67.1658Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.1434 78.3439L79.3777 112.362L138.706 124.144L145.472 90.1252L86.1434 78.3439Z",
    fill: "url(#paint6_linear_3209_49034)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.058 90.3003L86.4797 78.668L79.8631 111.937L138.441 123.569L145.058 90.3003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.266 72.9207L79.1763 59.7969L78.9773 60.7972L145.067 73.921L145.266 72.9207Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9791 85.8304L91.7188 84.3887L86.893 108.653L94.1534 110.094L98.9791 85.8304Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.404 96.4203L103.144 94.9785L99.9098 111.238L107.17 112.68L110.404 96.4203Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.931 106.51L114.67 105.068L112.929 113.823L120.19 115.264L121.931 106.51Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.739 100.09L129.479 98.6484L125.947 116.409L133.207 117.851L136.739 100.09Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.922 76.436C154.773 73.1632 151 70.5529 146.827 68.7586C142.653 66.9644 138.162 66.0225 133.619 65.9883C129.075 65.9541 124.571 66.8283 120.371 68.5596C116.17 70.2908 112.359 72.8441 109.161 76.0691C96.2663 89.0586 96.0477 110.209 108.66 123.474C114.201 129.301 121.627 132.982 129.623 133.863C137.619 134.745 145.67 132.771 152.349 128.291L176.977 153.888C177.282 154.205 177.701 154.387 178.14 154.396C178.58 154.405 179.005 154.238 179.323 153.934L185.459 148.037C185.776 147.733 185.959 147.315 185.968 146.875C185.977 146.436 185.81 146.011 185.505 145.694L160.883 120.1C165.604 113.635 167.895 105.714 167.354 97.7293C166.812 89.7445 163.473 82.2055 157.922 76.436ZM150.251 117.59C146.776 120.928 142.39 123.161 137.645 124.007C132.9 124.854 128.011 124.275 123.596 122.345C119.18 120.415 115.437 117.22 112.838 113.164C110.24 109.108 108.904 104.373 108.999 99.558C109.093 94.7431 110.615 90.0644 113.371 86.1135C116.126 82.1626 119.993 79.117 124.481 77.3618C128.969 75.6066 133.877 75.2206 138.585 76.2527C143.292 77.2848 147.588 79.6885 150.928 83.16C153.146 85.4651 154.888 88.1843 156.055 91.1621C157.221 94.14 157.789 97.3182 157.726 100.515C157.663 103.713 156.971 106.866 155.688 109.796C154.405 112.726 152.558 115.374 150.251 117.59Z",
    fill: "url(#paint7_linear_3209_49034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.313 93.2627C112.572 93.2627 112.568 97.519 115.313 97.519C118.058 97.519 118.058 93.2627 115.313 93.2627Z",
    fill: "url(#paint8_linear_3209_49034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.417 79.6294C127.04 79.4634 120.329 83.1606 116.76 88.7425C115.595 90.5638 118.902 92.1733 120.06 90.3607C123.015 85.7398 128.629 82.8047 134.703 82.9576C141.067 83.117 146.859 86.7552 149.925 91.8043C151.088 93.7195 154.136 91.979 152.985 90.0747C149.256 83.9599 142.035 79.8106 134.417 79.6294Z",
    fill: "url(#paint9_linear_3209_49034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.595 75.143C157.446 71.8702 153.673 69.2599 149.5 67.4657C145.326 65.6714 140.835 64.7295 136.292 64.6953C131.748 64.6611 127.244 65.5354 123.043 67.2666C118.843 68.9979 115.032 71.5511 111.834 74.7761C98.9391 87.7656 98.7206 108.916 111.333 122.181C116.874 128.008 124.3 131.688 132.296 132.569C140.292 133.451 148.343 131.476 155.022 126.996L179.648 152.595C179.953 152.912 180.371 153.094 180.811 153.103C181.251 153.112 181.676 152.945 181.993 152.641L188.13 146.744C188.447 146.44 188.63 146.022 188.639 145.582C188.647 145.143 188.481 144.718 188.176 144.401L163.547 118.804C168.269 112.341 170.561 104.421 170.021 96.4369C169.481 88.4526 166.144 80.9134 160.595 75.143ZM152.924 116.28C149.449 119.617 145.062 121.851 140.318 122.697C135.573 123.543 130.684 122.965 126.269 121.035C121.853 119.105 118.109 115.91 115.511 111.853C112.913 107.797 111.577 103.063 111.671 98.2476C111.766 93.4327 113.288 88.7539 116.043 84.8031C118.799 80.8522 122.666 77.8066 127.154 76.0514C131.642 74.2962 136.55 73.9102 141.258 74.9423C145.965 75.9743 150.261 78.3781 153.601 81.8496C155.819 84.1547 157.561 86.8738 158.728 89.8517C159.894 92.8295 160.462 96.0078 160.399 99.205C160.336 102.402 159.644 105.556 158.361 108.485C157.078 111.415 155.231 114.064 152.924 116.28Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.986 91.9678C115.245 91.9678 115.241 96.224 117.986 96.224C120.731 96.224 120.731 91.9678 117.986 91.9678Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.089 78.3364C129.713 78.1705 123.002 81.8677 119.433 87.4495C118.268 89.2709 121.574 90.8803 122.733 89.0678C125.688 84.4468 131.302 81.5117 137.376 81.6646C143.74 81.824 149.532 85.4623 152.598 90.5113C153.761 92.4265 156.809 90.686 155.658 88.7817C151.923 82.6495 144.71 78.5002 137.089 78.3364Z",
    fill: "#4EAEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9268 144.987H31.1619V149.322H31.9268V144.987Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7146 147.536V146.771H29.3763V147.536H33.7146Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.602 1.73589C129.391 1.64405 129.221 1.47776 129.124 1.26872C129.028 1.05968 129.012 0.822528 129.08 0.60248C129.09 0.568442 129.097 0.533254 129.099 0.497656C129.106 0.396452 129.08 0.295727 129.025 0.210559C128.97 0.12539 128.888 0.0603588 128.793 0.0251989C128.698 -0.00996103 128.594 -0.0133588 128.497 0.0155145C128.399 0.0443878 128.314 0.103979 128.253 0.185368C128.232 0.213778 128.215 0.244564 128.201 0.27709C128.109 0.48811 127.943 0.657945 127.733 0.754207C127.524 0.85047 127.287 0.866423 127.067 0.799025C127.033 0.78834 126.997 0.781743 126.962 0.779371C126.86 0.772008 126.758 0.798135 126.672 0.853781C126.586 0.909427 126.521 0.991551 126.486 1.08768C126.451 1.1838 126.449 1.28867 126.479 1.38635C126.509 1.48404 126.571 1.56919 126.654 1.62888C126.682 1.64989 126.713 1.66749 126.745 1.68129C126.957 1.77313 127.127 1.93942 127.223 2.14846C127.319 2.3575 127.335 2.59466 127.268 2.8147C127.257 2.84874 127.25 2.88393 127.248 2.91953C127.24 3.0221 127.266 3.12452 127.321 3.21103C127.377 3.29753 127.46 3.36334 127.557 3.39832C127.654 3.43331 127.759 3.43554 127.857 3.40466C127.956 3.37379 128.041 3.31153 128.1 3.22745C128.121 3.19904 128.139 3.16825 128.153 3.13573C128.245 2.92471 128.411 2.75487 128.62 2.65861C128.83 2.56235 129.067 2.54639 129.287 2.61379C129.321 2.62448 129.356 2.63107 129.392 2.63344C129.493 2.64037 129.594 2.61433 129.679 2.55922C129.765 2.50411 129.83 2.42291 129.865 2.32775C129.9 2.2326 129.903 2.12862 129.875 2.03137C129.846 1.93413 129.786 1.84885 129.705 1.7883C129.673 1.7665 129.638 1.74889 129.602 1.73589Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6565 33.8716C34.4453 33.7798 34.2753 33.6135 34.179 33.4045C34.0827 33.1954 34.0667 32.9583 34.1341 32.7382C34.1448 32.7042 34.1514 32.669 34.1538 32.6334C34.1607 32.5322 34.1347 32.4315 34.0795 32.3463C34.0244 32.2611 33.9431 32.1961 33.8479 32.1609C33.7527 32.1258 33.6486 32.1224 33.5513 32.1513C33.4539 32.1801 33.3686 32.2397 33.308 32.3211C33.287 32.3495 33.2694 32.3803 33.2556 32.4128C33.1636 32.6239 32.9972 32.7937 32.788 32.8899C32.5788 32.9862 32.3415 33.0022 32.1213 32.9348C32.0872 32.9241 32.052 32.9175 32.0164 32.9151C31.9151 32.9082 31.8143 32.9342 31.729 32.9893C31.6438 33.0444 31.5787 33.1256 31.5435 33.2208C31.5083 33.316 31.5049 33.4199 31.5338 33.5172C31.5627 33.6144 31.6224 33.6997 31.7038 33.7603C31.7323 33.7813 31.7631 33.7989 31.7956 33.8127C32.0068 33.9045 32.1768 34.0708 32.2731 34.2798C32.3694 34.4889 32.3854 34.726 32.318 34.9461C32.3073 34.9801 32.3007 35.0153 32.2983 35.0509C32.2914 35.1521 32.3174 35.2528 32.3726 35.338C32.4277 35.4232 32.509 35.4882 32.6042 35.5234C32.6995 35.5585 32.8035 35.5619 32.9008 35.533C32.9982 35.5042 33.0835 35.4446 33.1441 35.3632C33.1651 35.3348 33.1827 35.304 33.1965 35.2715C33.2885 35.0604 33.4549 34.8906 33.6641 34.7943C33.8733 34.6981 34.1106 34.6821 34.3308 34.7495C34.3649 34.7602 34.4001 34.7668 34.4357 34.7692C34.537 34.7761 34.6378 34.7501 34.7231 34.695C34.8083 34.6398 34.8734 34.5586 34.9086 34.4635C34.9438 34.3683 34.9472 34.2644 34.9183 34.1671C34.8894 34.0699 34.8297 33.9846 34.7483 33.924C34.7198 33.903 34.689 33.8854 34.6565 33.8716Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.673 166.487C169.462 166.395 169.292 166.229 169.196 166.02C169.099 165.811 169.084 165.574 169.151 165.353C169.162 165.319 169.168 165.284 169.171 165.249C169.178 165.147 169.152 165.047 169.096 164.962C169.041 164.876 168.96 164.811 168.865 164.776C168.769 164.741 168.665 164.738 168.568 164.766C168.471 164.795 168.385 164.855 168.325 164.936C168.304 164.965 168.286 164.996 168.272 165.028C168.18 165.239 168.014 165.409 167.805 165.505C167.596 165.601 167.358 165.617 167.138 165.55C167.104 165.539 167.069 165.533 167.033 165.53C166.932 165.523 166.831 165.549 166.746 165.605C166.661 165.66 166.596 165.741 166.56 165.836C166.525 165.931 166.522 166.035 166.551 166.132C166.58 166.23 166.639 166.315 166.721 166.375C166.749 166.397 166.78 166.414 166.812 166.428C167.024 166.52 167.194 166.686 167.29 166.895C167.386 167.104 167.402 167.341 167.335 167.561C167.324 167.595 167.318 167.631 167.315 167.666C167.308 167.767 167.334 167.868 167.389 167.953C167.445 168.038 167.526 168.103 167.621 168.139C167.716 168.174 167.82 168.177 167.918 168.148C168.015 168.119 168.1 168.06 168.161 167.978C168.182 167.95 168.2 167.919 168.213 167.887C168.305 167.676 168.472 167.506 168.681 167.41C168.89 167.313 169.127 167.297 169.348 167.365C169.382 167.375 169.417 167.382 169.453 167.384C169.554 167.391 169.655 167.365 169.74 167.31C169.825 167.255 169.89 167.174 169.925 167.079C169.961 166.984 169.964 166.88 169.935 166.782C169.906 166.685 169.847 166.6 169.765 166.539C169.737 166.518 169.706 166.501 169.673 166.487Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8065 17.9817C75.6526 17.9817 76.3385 17.2963 76.3385 16.4508C76.3385 15.6053 75.6526 14.9199 74.8065 14.9199C73.9603 14.9199 73.2744 15.6053 73.2744 16.4508C73.2744 17.2963 73.9603 17.9817 74.8065 17.9817Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.555 37.1076C185.401 37.1076 186.087 36.4222 186.087 35.5768C186.087 34.7313 185.401 34.0459 184.555 34.0459C183.708 34.0459 183.022 34.7313 183.022 35.5768C183.022 36.4222 183.708 37.1076 184.555 37.1076Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.878 82.759C176.724 82.759 177.41 82.0736 177.41 81.2281C177.41 80.3827 176.724 79.6973 175.878 79.6973C175.032 79.6973 174.346 80.3827 174.346 81.2281C174.346 82.0736 175.032 82.759 175.878 82.759Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.1507 7.77853C6.99683 7.77853 7.68275 7.09314 7.68275 6.24766C7.68275 5.40219 6.99683 4.7168 6.1507 4.7168C5.30457 4.7168 4.61865 5.40219 4.61865 6.24766C4.61865 7.09314 5.30457 7.77853 6.1507 7.77853Z",
    fill: "#47E6B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3209_49034",
    x: 0.618652,
    y: 0,
    width: 192.021,
    height: 178.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3209_49034"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3209_49034",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3209_49034",
    x1: 87.3123,
    y1: 160.033,
    x2: 87.3123,
    y2: 28.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3209_49034",
    x1: 9573.17,
    y1: 14460.1,
    x2: 9573.17,
    y2: 8788.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3209_49034",
    x1: 8793.65,
    y1: 7984.19,
    x2: 8793.65,
    y2: 5781.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3209_49034",
    x1: 9573.17,
    y1: 21780.3,
    x2: 9573.17,
    y2: 16108.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3209_49034",
    x1: 8793.65,
    y1: 12562.9,
    x2: 8793.65,
    y2: 10360.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3209_49034",
    x1: 74393.4,
    y1: 91273.1,
    x2: 85888.1,
    y2: 33387.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3209_49034",
    x1: 16822.5,
    y1: 38429.1,
    x2: 18692.3,
    y2: 29013.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3209_49034",
    x1: 142.656,
    y1: 154.397,
    x2: 142.656,
    y2: 65.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3209_49034",
    x1: 115.313,
    y1: 97.5168,
    x2: 115.313,
    y2: 93.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3209_49034",
    x1: 28578.2,
    y1: 6386.71,
    x2: 28578.2,
    y2: 5611.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3209_49034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184.021,
    height: 170.103,
    fill: "white",
    transform: "translate(4.61865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.4fa06967.svg";
export { ForwardRef as ReactComponent };